// extracted by mini-css-extract-plugin
export var avatar = "_lx-3";
export var avatarContainer = "_lx-2";
export var avatarSpacer = "_lx-5";
export var avatarSpacerContainer = "_lx-4";
export var avatarStackContainer = "_lx-1";
export var bubble = "_lx-0";
export var remainderBubble = "_lx-6";